import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import {
  accidentRegistrationTypeEnumOptions,
  incidentResponsibleEnumOptions,
  insurancePolicyStatusEnumOptions,
} from '~/shared/config/constants'
import {
  AutocompleteInput,
  DatePickerInput,
  NumericInput,
  Switch,
  TextInput,
} from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type RegistrationProps = {
  disabled: boolean
  loading: boolean
}

export function Registration({ disabled, loading }: RegistrationProps) {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('form.registration')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={6}>
          <NumericInput
            label='form.accident participants number'
            placeholder='form.specify accident participants number'
            name='accidentParticipantsNumber'
            readOnly={disabled}
            skeletonShow={loading}
            numericProps={{ thousandSeparator: '', decimalScale: 0 }}
          />
        </Grid>
        <Grid xs={6}>
          <AutocompleteInput
            options={accidentRegistrationTypeEnumOptions}
            label='form.registration type'
            placeholder='form.select registration type'
            name='accidentRegistrationType'
            readOnly={disabled}
            skeletonShow={loading}
          />
        </Grid>

        <Grid xs={2}>
          <Switch
            labelI18n='form.decision'
            name='protocol'
            readOnly={disabled}
            skeletonShow={loading}
            formControlProps={{ sx: { marginTop: '40px' } }}
          />
        </Grid>
        <Grid xs={4}>
          <AutocompleteInput
            options={incidentResponsibleEnumOptions}
            label='form.guilt'
            name='culpability'
            readOnly={disabled}
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <DatePickerInput
            label='form.protocol receipt date'
            placeholder='form.select protocol receipt date'
            name='protocolReceivingDate'
            skeletonShow={loading}
            readOnly={disabled}
          />
        </Grid>

        <Grid xs={4}>
          <TextInput
            label='form.insurance company'
            placeholder='form.insurance company'
            name='insuranceCompany'
            skeletonShow={loading}
            readOnly
          />
        </Grid>
        <Grid xs={4}>
          <TextInput
            label='form.insurance policy number'
            placeholder='form.insurance policy number'
            name='insurancePolicyNumber'
            skeletonShow={loading}
            readOnly
          />
        </Grid>
        <Grid xs={4}>
          <AutocompleteInput
            options={insurancePolicyStatusEnumOptions}
            label='form.policy status'
            placeholder='form.select policy status'
            name='insurancePolicyStatus'
            skeletonShow={loading}
            readOnly
          />
        </Grid>

        <Grid xs={12}>
          <br />
          <ContainerTitle>{t('form.participant 2')}</ContainerTitle>
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.insurance company'
            placeholder='form.enter insurance company'
            name='insuranceCompany2'
            readOnly={disabled}
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.insurance policy number'
            placeholder='form.enter insurance policy number'
            name='insurancePolicyNumber2'
            readOnly={disabled}
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <AutocompleteInput
            options={insurancePolicyStatusEnumOptions}
            label='form.policy status'
            placeholder='form.select policy status'
            name='insurancePolicyStatus2'
            readOnly={disabled}
            skeletonShow={loading}
          />
        </Grid>

        <Grid xs={12}>
          <br />
          <ContainerTitle>{t('form.participant 3')}</ContainerTitle>
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.insurance company'
            placeholder='form.enter insurance company'
            name='insuranceCompany3'
            readOnly={disabled}
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.insurance policy number'
            placeholder='form.enter insurance policy number'
            name='insurancePolicyNumber3'
            readOnly={disabled}
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <AutocompleteInput
            options={insurancePolicyStatusEnumOptions}
            label='form.policy status'
            placeholder='form.select policy status'
            name='insurancePolicyStatus3'
            readOnly={disabled}
            skeletonShow={loading}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
